import React from 'react';
import { Avatar, Icon } from 'components/ui';
import useUserStore from 'store/useUserStore';
import Wordmark from './Wordmark';
import styles from './TopBar.module.scss';

export interface ITopBarProps {
  onOpenMenu: () => void;
  menuButtonRef?: React.RefObject<HTMLButtonElement>;
}

export default function TopBar({ onOpenMenu, menuButtonRef }: ITopBarProps) {
  const user = useUserStore(s => s.user);
  const displayName =
    user != null
      ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.name
      : '';

  return (
    <header className={styles.topBar}>
      <button
        ref={menuButtonRef}
        type="button"
        className={styles.menuButton}
        aria-label="Open menu"
        onClick={onOpenMenu}
      >
        <Icon name="menu" size={24} />
      </button>
      <Wordmark className={styles.wordmark} />
      {user ? (
        <Avatar
          size={32}
          src={user.profileImage}
          firstName={user.firstName}
          lastName={user.lastName}
          name={displayName}
        />
      ) : (
        <span className={styles.avatarSpacer} aria-hidden />
      )}
    </header>
  );
}
